var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutopayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 36,
    viewBox: "0 0 142 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9243 10.7931C17.9243 5.68198 14.0516 1.53906 8.96213 1.53906C3.87263 1.53906 0 5.68198 0 10.7931V29.3011H2.24072C2.24072 25.4678 5.25048 22.3608 8.96213 22.3608C12.6738 22.3608 15.6835 25.4686 15.6835 29.3011H17.9243V10.7931Z",
    fill: "#199BFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4019 0L24.6472 29.3022H29.7573L30.8689 22.8684H37.2187L38.3303 29.3022H43.5892L37.8336 0H30.4019ZM31.583 18.8515L34.0434 4.71248L36.5038 18.8515H31.583Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9678 22.5807C54.9678 24.6706 53.8166 25.6955 52.2686 25.6955C50.7206 25.6955 50.0462 24.7943 50.0462 22.8674V7.86813H45.1245V23.5228C45.1245 27.7028 47.1882 29.6699 50.2049 29.6699C52.6653 29.6699 54.1736 28.3992 54.9678 26.6369V29.3004H59.8895V7.86813H54.9678V22.5807Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8111 3.56542H67.732V7.86904H71.1056V11.5984H67.732V23.3182C67.732 24.7937 68.3271 25.4491 69.5973 25.4491C70.2328 25.4491 70.8279 25.3672 71.1056 25.2443V29.1375C70.7089 29.3013 69.7568 29.4652 68.6452 29.4652C64.5574 29.4652 62.8111 27.58 62.8111 23.7278V3.56542Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4241 7.49997C75.8999 7.49997 72.6453 10.2454 72.6453 15.5322V21.7201C72.6453 26.925 75.8999 29.6704 80.3844 29.6704C84.8689 29.6704 88.2823 26.925 88.2823 21.6382V15.4502C88.2823 10.2044 84.988 7.49997 80.4241 7.49997ZM83.3217 21.8438C83.3217 24.4663 82.3696 25.778 80.4241 25.778C78.4786 25.778 77.5662 24.4663 77.5662 21.8438V15.2872C77.5662 12.6237 78.5587 11.353 80.4241 11.353C82.2895 11.353 83.3217 12.6237 83.3217 15.3281V21.8438Z",
    fill: "#282828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6637 10.4918C96.4976 8.85239 98.1249 7.49978 100.506 7.49978C104.038 7.49978 106.38 9.95765 106.38 15.0806V22.0067C106.38 27.1706 103.919 29.6702 100.308 29.6702C98.0052 29.6702 96.3778 28.4822 95.6637 26.8429V36H90.7421V7.86925H95.6637V10.4918ZM98.6399 25.8188C100.466 25.8188 101.419 24.63 101.419 22.0485V15.0821C101.419 12.4187 100.386 11.3938 98.6399 11.3938C96.7349 11.3938 95.6233 12.7464 95.6233 15.4099V21.7617C95.6233 24.4252 96.6159 25.8188 98.6399 25.8188Z",
    fill: "#282828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.244 10.3281C118.49 8.6068 117.101 7.49997 114.799 7.49997C111.306 7.49997 108.687 9.99959 108.687 15.2044V22.0077C108.687 27.2125 111.147 29.6712 114.561 29.6712C116.942 29.6712 118.45 28.3186 119.244 26.5973V29.3017H124.166V7.86865H119.244V10.3281ZM119.284 21.7209C119.284 24.3844 118.172 25.778 116.267 25.778C114.6 25.778 113.648 24.7121 113.648 22.0896V15.1225C113.648 12.459 114.6 11.3112 116.387 11.3112C118.292 11.3112 119.285 12.7048 119.285 15.4502L119.284 21.7209Z",
    fill: "#282828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.043 20.9003L137.178 7.86813H142L134.027 35.9997H129.089L131.543 27.5807L125.549 7.86813H130.788L134.043 20.9003Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopayLogo);
export default __webpack_public_path__ + "static/media/autopay-logo.74a5e8dd47f59c12a7bca8d0a04b04e6.svg";
export { ForwardRef as ReactComponent };